import React from 'react';
import styles from '@/styles/CardBox.module.scss';

type props = {
    headingText: string,
    children?: React.ReactNode

}
export const CardBox = ({ headingText, children }: props) => {
    return (
        <section className={styles.cardContainer}>
            <div>
                <div className={styles.cardItemheader}>
                    <p className={styles.cardItemlabel}>{headingText}</p>
                </div>
                <>{children}</>
            </div>
        </section>
    );
}
